import React from 'react';

import HelpTooltip from '../SteppedForm/HelpTooltip';

import { Typography } from '@material-ui/core';

import { Step, ButtonField } from '../SteppedForm';

const StepPlate = (props) => {
  return (
    <Step
      id="plate"
      title={'Vehicle - ' + (props.stateconfig().authName || props.stateconfig().plateName)}
      nonext
      skip={(formdata) =>
        formdata.onboardcar === false ||
        props.stateconfig().onlyownplate ||
        props.stateconfig().noplates ||
        !props.networkconfig().platelease ||
        formdata.tiger === true
      }
      // skip={ () => false && (props.state.formdata.onboardcar === false || stateconfig().onlyownplate || stateconfig().noplates || !networkconfig().platelease || props.state.formdata.tiger === true) }
    >
      <Typography variant="body1" class="formQuestion">
        Which company or person is providing you with your Taxi{' '}
        {props.stateconfig().authName || props.stateconfig().plateName}?
      </Typography>
      <HelpTooltip title="If the plate is owned by your company or a trust, please use the option 'I am leasing a plate from someone else'">
        <ButtonField
          id="plateOwnership"
          value="own"
          label={'I own my own ' + (props.stateconfig().authName || props.stateconfig().plateName)}
        />
      </HelpTooltip>
      {props.networkconfig().networkplatelease ? (
        <HelpTooltip title="Please refer to the Frequently Asked Questions page for more details">
          <ButtonField
            id="plateOwnership"
            value="13cabs"
            label={
              'I want to lease a ' +
              (props.stateconfig().authName || props.stateconfig().plateName) +
              ' from ' +
              props.state.formdata.network
            }
          />
        </HelpTooltip>
      ) : (
        ''
      )}

      <HelpTooltip
        title={`Use this option if you have already arranged to lease a Taxi Plate from someone else. You will need to provide their details, and have them sign an 'Appointment By Owner' document. This document will need to be submitted to ${
          props.inStates(['nsw']) ? 'Services NSW' : 'Roads & Maritime Services (RMS)'
        }`}>
        <ButtonField
          id="plateOwnership"
          value="other"
          label={
            'I am leasing a ' +
            (props.stateconfig().authName || props.stateconfig().plateName) +
            ' from someone else'
          }
        />
      </HelpTooltip>
    </Step>
  );
};

export default StepPlate;
